<template>
    <modal-window class="session-expired">
        <div class="session-expired__wrapper">
            <div class="session-expired__title">
                {{ $t('common.sessionExpired') }}
            </div>
            <submit-button class="session-expired__button" @click="startOver">
                {{ $t('common.startOver') }}
            </submit-button>
        </div>
    </modal-window>
</template>

<script>
    import ModalWindow from './ModalWindow.vue'

    export default {
        name: 'SessionExpired',
        methods: {
            startOver() {
                this.$emit('startOver')
            }
        },
        components: {
            ModalWindow
        }
    }
</script>

<style lang="less">
    .session-expired {
        &__title {
            padding: 0 0 20px;
            font-size: 16px;
            letter-spacing: 1px;
            word-spacing: 3px;
            text-transform: uppercase;
        }

        &__button {
            width: 100%;
        }

        .modal-window {
            &__container {
                overflow: hidden;
            }

            &__close {
                display: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SessionExpired.vue